import ReactDOM, { Root } from "react-dom/client"
import reportWebVitals from "./reportWebVitals"
import config from "./config.json"
import App from "./App"
import "./root.css"

const root: Root = ReactDOM.createRoot(
  document.querySelector("body") as HTMLElement,
)
root.render(<App />)

config.debug && reportWebVitals(console.log)
